'use client';

import { useState, useEffect } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Iconify from '../iconify';
import {useTranslate} from "src/locales";

// ----------------------------------------------------------------------

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  const {t} = useTranslate();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    const savedConsent = localStorage.getItem('cookieConsent');

    if (!savedConsent) {
      // Pokaż dialog po krótkiej chwili
      const timer = setTimeout(() => {
        setOpen(true);
      }, 1000);
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [mounted]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setOpen(false);

    // Aktualizuj zgody - przyznaj dostęp do analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setOpen(false);

    // Zgody pozostają "denied" - możesz to potwierdzić
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }
  };

  if (!mounted) return null;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24,
        },
      }}
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* @ts-ignore */}
          <Iconify icon="mdi:cookie" width={28} />
          <Typography variant="h6">{t('cookieConsent.title' as any)}</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {t('cookieConsent.description' as any)}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleDecline}
          size="large"
        >
          {t('cookieConsent.decline' as any)}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAccept}
          size="large"
          autoFocus
        >
          {t('cookieConsent.accept' as any)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
